
import React from "react";
import Nabvar from "../../common/Nabvar";
import Sidebar from "../../common/Sidebar";
import Publihser from "./Publihser";
import Body from "../../ui/Body"

function PublihserList() {
    // theme context
    return (
        <>
            <Sidebar />
            <Nabvar />
            <Body >
                <Publihser />
            </Body>
        </>
    );
}

export default PublihserList